module.exports = __webpack_public_path__ + "img/safe_map.90340386.png";